<template>
  <div style="width:100%">
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-list two-line>
            <template v-for="(item, index) in items">
              <v-subheader
                v-if="item.header"
                :key="index"
              >
                {{ item.header }}
              </v-subheader>

              <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider>

              <v-list-tile
                v-else
                :key="index"
                avatar
                ripple
                @click="toggle(item)"
              >
                <v-list-tile-avatar>
                  <i class="material-icons" style="font-size:35px">{{item.avatar}}</i>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" style="white-space:normal; height:fit-content;"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action v-if="item.is_service">
                  <v-list-tile-action-text>Complete</v-list-tile-action-text>
                  <v-icon
                    v-if="!item.complete"
                    color="grey lighten-1"
                  >
                    radio_button_unchecked
                  </v-icon>

                  <v-icon
                    v-else
                    color="indigo darken-2"
                  >
                    radio_button_checked
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import services from '@/services/services'

export default {
  name: 'admin-event-detail',
  props: {
    event: Object
  },
  methods: {
    pretty_list(list) {
      let list_string = ''
      list.forEach((item) => {
        list_string += item + ', ';
      })
      return list_string
    },
    toggle (item) {
      services.toggleEventItemStatus({event_id: this.event.id, type: item.type, key: item.key, complete: !item.complete})
        .then((resp) => {
          item.complete = !item.complete;
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  mounted() {
    let flat_service_list = []
    this.$store.getters.getServiceList.forEach((category) => {
      category.services.forEach((service) => {
        flat_service_list.push(service)
      })
    })
    services.getEventDetail(0, this.event.id)
      .then((resp) => {
        let event_data = resp.data
        event_data.services.forEach((key) => {
          let service = flat_service_list.filter((obj) => obj.key == key.key)[0]
          this.items.push({ divider: true, inset: true, is_service: false, })
          this.items.push({
            avatar: 'room_service',
            title: service.title + ' Service',
            subtitle: 'In Progress',
            complete: key.complete,
            is_service: true,
            type: 'service',
            key: service.key
          })
        })

        event_data.requests.forEach((request) => {
          this.items.push({ divider: true, inset: true })
          this.items.push({
            avatar: 'star',
            title: request.request,
            subtitle: 'In Progress',
            complete: request.complete,
            is_service: true,
            type: 'request',
            key: request.id
          })
        })
      })
      .catch((err) => {
        console.log(err)
      })
  },
  data () {
    return {
      selected: [],
      items: [
        { 
          header: moment(this.event.start_date).format('MMMM Do YYYY'),
          is_service: false,
        },
        {
          avatar: 'account_circle',
          title: this.event.owner,
          subtitle: 'category: Owner',
          is_service: false,
        },
        { divider: true, inset: true, is_service: false },
        {
          avatar: 'event',
          title: this.event.title || '* No Title Entered *',
          subtitle: 'category: Title',
          is_service: false,
        },
        { divider: true, inset: true, is_service: false },
        {
          avatar: 'description',
          title: this.event.description || '* No Description Entered *',
          subtitle: 'category: Description',
          is_service: false,
        },
        { divider: true, inset: true, is_service: false },
        {
          avatar: 'location_on',
          title: this.event.location || '* No Location Entered *',
          subtitle: 'category: Location',
          is_service: false
        }
      ],
    }
  }
}
</script>

<style scoped>
</style>
